export default "__VITE_ASSET__dc8761a4__"